import { cspNonce, emotionCache } from './common/csp'
import { CacheProvider } from '@emotion/react'
import { MotionConfig } from 'framer-motion'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import NewStarterResponse from './pages/NewStarterResponse'

// A silent MSAL response returns to the app origin inside a hidden iframe.
// Do not boot the full React/auth tree there, otherwise it can start another
// silent request recursively. The parent MSAL instance reads the iframe hash.
const hash = new URLSearchParams(window.location.hash.slice(1))
const isSilentAuthFrame =
  window.self !== window.top && (hash.has('code') || hash.has('error') || hash.has('state'))

// A tab opened before a deploy can ask for a lazy chunk the new build no longer has
// (old assets are gone after the blue/green handover). Reload once to pick up the new
// build; the 60 s guard stops a reload loop when the chunk is missing for another reason.
window.addEventListener('vite:preloadError', (event) => {
  const key = 'hub:chunk-reload-at'
  try {
    if (Date.now() - Number(sessionStorage.getItem(key) || 0) < 60_000) return
    sessionStorage.setItem(key, String(Date.now()))
  } catch {
    return
  }
  event.preventDefault()
  window.location.reload()
})

if (!isSilentAuthFrame) {
  // Disable StrictMode to prevent double-mounting (like duo_utility)
  // Email confirmations have their own minimal page and do not mount sign-in,
  // permissions, directory loaders, navigation, or the app's top bar.
  const isStarterResponse = window.location.pathname === '/new-starters/respond'
  createRoot(document.getElementById('root')!).render(
    <CacheProvider value={emotionCache}>
      <MotionConfig nonce={cspNonce}>
        {isStarterResponse ? <NewStarterResponse /> : <App />}
      </MotionConfig>
    </CacheProvider>
  )
}
